//import PrescriptionTemplates from './screens/index.vue';
const PrescriptionTemplates = () => import('./screens/index.vue')

import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { checkUserPermissions } from '@/services/auth';

const prescriptionTemplatesRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.PRESCRIPTION_TEMPLATES_VIEW,
    PERMISSIONS_KEYS.PRESCRIPTION_TEMPLATES_INSERT,
    PERMISSIONS_KEYS.PRESCRIPTION_TEMPLATES_EDIT,
  ])
) {
  prescriptionTemplatesRoutes.push({
    path: '/templates-de-prescricao',
    name: 'Cadastro / Consulta|Composição Definida',
    component: PrescriptionTemplates,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
}

export { prescriptionTemplatesRoutes };
